import {useCallback, useRef} from 'react';

// Maria, 19 October 2026: on the staff Profile tab, the question column is as wide as its longest question, and the space
// between the questions and the answers is the same in both boxes. As the window narrows, the white space to the right
// of the answers goes first, then the space between the columns. On a phone each answer is under its question.
const GAP = '48px';
const MIN_GAP = '12px';
export const FIT_COLUMNS_SX = {
    gridTemplateColumns: {
        xs: 'minmax(0, 1fr)',
        sm: `var(--label-w, 180px) minmax(${MIN_GAP}, ${GAP}) minmax(min(var(--answer-w, 0px), 100%), 1fr)`
    },
    columnGap: 0,
    '& > [data-fit-label]': {whiteSpace: {sm: 'nowrap'}},
    '& > :last-child': {gridColumn: {xs: 1, sm: 3}}
};

const textWidth = element => {
    const range = document.createRange();
    range.selectNodeContents(element);
    return Math.ceil(range.getBoundingClientRect().width);
};

// a ref for the box: the widest question and answer in it are kept on the box, for FIT_COLUMNS_SX
export const useFitColumns = () => {
    const observer = useRef(null);
    return useCallback(node => {
        observer.current?.disconnect();
        if (!node || typeof ResizeObserver === 'undefined') return;
        let frame = 0;
        const measure = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                const widest = selector => Math.max(0, ...[...node.querySelectorAll(selector)].map(textWidth));
                node.style.setProperty('--label-w', `${widest('[data-fit-label]')}px`);
                node.style.setProperty('--answer-w', `${widest('[data-fit-answer]')}px`);
            });
        };
        observer.current = new ResizeObserver(measure);
        observer.current.observe(node);
        new MutationObserver(measure).observe(node, {childList: true, subtree: true, characterData: true});
        measure();
        // the bold questions are measured again once the fonts have loaded
        document.fonts?.ready.then(measure);
    }, []);
};
